const lang = {
  component: {
    ChatbotPopup: {
      pTagFirst: `Hello, I’m Alma.`,
      pTagSecond: `I’ve been created to answer your questions about`,
      pTagThird: `child growth`,
      pTagFourth: `. What can I help you with?`,
      button: {
        copy: `Ask Alma`,
        label: `Ask a question`
      }
    },
    Chatbot: {
      promptBtnLabel: `Chat with Alma`,
      disclaimer: `The information you share helps us provide useful answers for more information, check out our`,
      privacyPolicy: `privacy policy`,
      submitBtnTxt: `Send`
    }
  }
};

export default lang;
